import { useRef } from "react";

interface PillSearchBarProps {
  pills: string[];
  onPillsChange: (pills: string[]) => void;
  inputValue: string;
  onInputChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export function PillSearchBar({
  pills,
  onPillsChange,
  inputValue,
  onInputChange,
  placeholder,
  ariaLabel,
}: PillSearchBarProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const commitPill = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    if (pills.includes(trimmed)) {
      onInputChange("");
      return;
    }
    onPillsChange([...pills, trimmed]);
    onInputChange("");
  };

  const removePill = (index: number) => {
    onPillsChange(pills.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      commitPill();
      return;
    }
    if (e.key === "Backspace" && inputValue === "" && pills.length > 0) {
      e.preventDefault();
      removePill(pills.length - 1);
    }
  };

  const handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      inputRef.current?.focus();
    }
  };

  return (
    <div className="employee-search" ref={containerRef}>
      <div
        className="employee-search__input-container"
        onClick={handleContainerClick}
      >
        {pills.map((term, index) => (
          <span key={`${term}-${index}`} className="employee-search__pill">
            <span className="employee-search__pill-name">{term}</span>
            <button
              type="button"
              className="employee-search__pill-remove"
              onClick={() => removePill(index)}
              aria-label={`Remove filter ${term}`}
            >
              ×
            </button>
          </span>
        ))}
        <input
          ref={inputRef}
          type="text"
          className="employee-search__input"
          placeholder={pills.length > 0 ? "" : placeholder}
          value={inputValue}
          onChange={(e) => onInputChange(e.target.value)}
          onKeyDown={handleKeyDown}
          aria-label={ariaLabel}
        />
      </div>
    </div>
  );
}
